export const colourValues = {
  legacyBrand: {
    700: '#2A69AC',
    800: '#153E75',
    900: '#1A365D',
  },
  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3E66EC',
    600: '#2563EB',
    700: '#155DFC',
    800: '#1E40AF',
    900: '#1E3A8A',
  },
  ink: '#111318',
  neutral: {
    0: '#FFFFFF',
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
  danger: {
    50: '#FEF2F2',
    500: '#E04040',
    600: '#C53030',
    700: '#B91C1C',
    800: '#991B1B',
  },
  supporting: {
    border: '#C9CDD6',
    text: '#52586A',
  },
  search: {
    border: '#D9D9DC',
  },
} as const

export const colourTokens = {
  // Keep existing brand token consumers stable until their intentional migration.
  brand: {
    700: { value: colourValues.legacyBrand[700] },
    800: { value: colourValues.legacyBrand[800] },
    900: { value: colourValues.legacyBrand[900] },
  },
  assiduous: {
    ink: { value: colourValues.ink },
    blue: {
      50: { value: colourValues.blue[50] },
      100: { value: colourValues.blue[100] },
      200: { value: colourValues.blue[200] },
      300: { value: colourValues.blue[300] },
      400: { value: colourValues.blue[400] },
      500: { value: colourValues.blue[500] },
      600: { value: colourValues.blue[600] },
      700: { value: colourValues.blue[700] },
      800: { value: colourValues.blue[800] },
      900: { value: colourValues.blue[900] },
    },
    neutral: {
      0: { value: colourValues.neutral[0] },
      50: { value: colourValues.neutral[50] },
      100: { value: colourValues.neutral[100] },
      200: { value: colourValues.neutral[200] },
      300: { value: colourValues.neutral[300] },
      400: { value: colourValues.neutral[400] },
      500: { value: colourValues.neutral[500] },
      600: { value: colourValues.neutral[600] },
      700: { value: colourValues.neutral[700] },
      800: { value: colourValues.neutral[800] },
      900: { value: colourValues.neutral[900] },
    },
    danger: {
      50: { value: colourValues.danger[50] },
      500: { value: colourValues.danger[500] },
      600: { value: colourValues.danger[600] },
      700: { value: colourValues.danger[700] },
      800: { value: colourValues.danger[800] },
    },
    supporting: {
      border: { value: colourValues.supporting.border },
      text: { value: colourValues.supporting.text },
    },
    search: {
      border: { value: colourValues.search.border },
    },
  },
}
